module.exports = __webpack_public_path__ + "img/26.298c40fa.jpg";